import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PlatformType } from '@/constants'

export interface GlobalState {
  userName: string
  token: string
  tenant: string
  tenant_id: string
  user_id: string
  selectedMenuItems: Array<string>
  userLogoUrl: string
  userLogoTitle: string
  isPictureInsteadTitle: boolean | string
  platformType: string
  language: string
  supportedPlatforms: string
  isAdmin: boolean
}

const initialState: GlobalState = {
  user_id: '',
  userName: '',
  token: '',
  tenant: '',
  tenant_id: '',
  selectedMenuItems: [],
  userLogoUrl: '',
  userLogoTitle: '',
  isPictureInsteadTitle: false,
  platformType: PlatformType.Bigcommerce,
  supportedPlatforms: PlatformType.All,
  language: 'en',
  isAdmin: false,
}

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    updateUserName: (state, action: PayloadAction<string>) => {
      state.userName = action.payload
    },
    updateToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload
    },
    updateUserId: (state, action: PayloadAction<string>) => {
      state.user_id = action.payload
    },
    updateTenant: (state, action: PayloadAction<string>) => {
      state.tenant = action.payload
    },
    updateTenantId: (state, action: PayloadAction<string>) => {
      state.tenant_id = action.payload
    },
    updateUserLogoUrl: (state, action: PayloadAction<string>) => {
      state.userLogoUrl = action.payload
    },
    updateUserLogoTitle: (state, action: PayloadAction<string>) => {
      state.userLogoTitle = action.payload
    },
    updateUserIsPictureInsteadTitle: (
      state,
      action: PayloadAction<boolean | string>,
    ) => {
      state.isPictureInsteadTitle = action.payload
    },
    updateUserIsAdmin: (state, action: PayloadAction<boolean>) => {
      state.isAdmin = action.payload
    },
    setSelectedMenuItems: (state, action: PayloadAction<string>) => {
      state.selectedMenuItems = [action.payload]
    },
    setPlatformType: (state, action: PayloadAction<string>) => {
      state.platformType = action.payload
    },
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload
    },
    setSupportedPlatform: (state, action: PayloadAction<string>) => {
      state.supportedPlatforms = action.payload
    },
  },
})

export const {
  updateUserName,
  updateUserId,
  updateToken,
  updateTenant,
  updateTenantId,
  updateUserLogoUrl,
  updateUserIsPictureInsteadTitle,
  updateUserLogoTitle,
  setSelectedMenuItems,
  setPlatformType,
  setLanguage,
  setSupportedPlatform,
  updateUserIsAdmin,
} = globalSlice.actions

export default globalSlice.reducer
